/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Middleware } from '@reduxjs/toolkit';
import { hubConnection } from 'signalr-no-jquery';
import { basePathHelper } from '../../../setup/base-path.helper';
import { RootState } from '../../../setup/store/store';
import { AppointmentDropInPosition } from '../../appointments/models/appointment-drop-in-position.model';
import { AppointmentDropIn } from '../../appointments/models/appointment-drop-in.model';
import { appointmentDropInPositionSlice } from '../../appointments/store/appointment-drop-in-positions.slice';
import { appointmentDropInSlice } from '../../appointments/store/appointment-drop-ins.slice';
import { maxSignalRDisconnects, setSignalRStatus } from './signalr.slice';

const { careerHubBaseUrl } = basePathHelper;

// very simple implementation of a signalR middleware
export const createSignalRMiddleware: () => Middleware = () => (api) => {
    const dispatch = api.dispatch;

    const connection = hubConnection(careerHubBaseUrl);

    const init = () => {
        connection.stop();

        connection
            .start()
            .done(() => {
                dispatch(setSignalRStatus('connected'));
            })
            .fail(() => {
                dispatch(setSignalRStatus('disconnected'));
            });
    };

    connection.reconnecting(() => {
        dispatch(setSignalRStatus('reconnecting'));
    });

    connection.disconnected(() => {
        dispatch(setSignalRStatus('disconnected'));
    });

    const hubProxy = connection.createHubProxy('StudentMeHub');
    hubProxy.on('dropInPosition', (position: AppointmentDropInPosition) => {
        dispatch(appointmentDropInPositionSlice.actions.appointmentDropInPositionSetOne(position));
    });
    hubProxy.on('dropIn', (dropIn: AppointmentDropIn) => {
        dispatch(appointmentDropInSlice.actions.appointmentDropInSetOne(dropIn));
    });
    hubProxy.on('dropInRemoved', (appointmentId: number) => {
        dispatch(appointmentDropInSlice.actions.appointmentDropInRemoveOne(appointmentId));
    });

    return next => (action: unknown) => {
        if (!setSignalRStatus.match(action)) {
            return next(action);
        }

        switch (action.payload) {
            case 'disconnected':
            case 'initializing': {
                const state = api.getState() as RootState;
                if (state.signalR.disconnects < maxSignalRDisconnects) {
                    init();
                }
                break;
            }
        }
        return next(action);
    };
};
